import i18n from '@ohif/i18n';

const NS = 'Organization';

export function tDicomAbstractName(key: string): string {
  return i18n.t(`devices.dicom.abstract.${key}.name`, { ns: NS });
}

export function tDicomAbstractDescription(key: string): string {
  return i18n.t(`devices.dicom.abstract.${key}.description`, { ns: NS });
}

export function tDicomAbstractSecurityNote(key: string): string {
  return i18n.t(`devices.dicom.abstract.${key}.securityNote`, { ns: NS });
}

export function tDicomTransferSyntaxName(key: string): string {
  return i18n.t(`devices.dicom.transfer.${key}.name`, { ns: NS });
}
